import { render, staticRenderFns } from "./CourseDetailAdmin.vue?vue&type=template&id=5a2eb10d&"
import script from "./CourseDetailAdmin.vue?vue&type=script&lang=js&"
export * from "./CourseDetailAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports